import React from 'react'

const WaveItem = ({
  backgroundImage,
  topOffset,
  leftOffset,
  waveWidth,
  d,
  strokeColor
}) => {
  return (
    <div
      className='h-[220px] w-[220px] relative '
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain'
      }}
    >
      <div
        className='wave-container'
        style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: topOffset,
          left: leftOffset
        }}
      >
        <svg
          viewBox='0 0 1230 200'
          xmlns='http://www.w3.org/2000/svg'
          className='wave-line'
          style={{
            width: waveWidth,
            height: '100%'
          }}
        >
          <path
            d={d}
            stroke={strokeColor}
            strokeWidth='5'
            fill='none'
            style={{
              strokeDasharray: 1500,
              strokeDashoffset: 1500,
              animation: 'draw 3s linear infinite'
            }}
          />
        </svg>
      </div>
    </div>
  )
}

const ArrowButton = ({ onClick, icon, strokeColor }) => {
  return (
    <div
      className='relative w-[80px] h-[80px] rounded-lg flex justify-center items-center cursor-pointer mr-4 mt-[-140px]'
      onClick={onClick}
    >
      <svg
        width='100%'
        height='100%'
        viewBox='0 0 100 100'
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          transform: 'rotate(-90deg)'
        }}
      >
        <circle
          cx='50'
          cy='50'
          r='48'
          fill='none'
          stroke={strokeColor}
          strokeWidth='2'
          strokeDasharray='4, 1'
          strokeDashoffset='0'
          style={{
            animation: 'dash-animation 20s linear infinite'
          }}
        />
      </svg>
      <img src={icon} alt='Down Arrow' className='h-5 w-4 cursor-pointer' />
    </div>
  )
}

const BottomSection = ({
  pointer,
  down,
  scrollToSection,
  nextRef,
  d,
  width,
  left,
  strokeColor
}) => {
  return (
    <>
      <div className='flex justify-between items-center ml-1 px-14 tablet:hidden mobile:hidden maxScreen:max-w-[1400px] extraScreen:max-w-[1600px] maxScreen:mx-auto extraScreen:mx-auto'>
        <div  style={{marginLeft: nextRef==="secondSection" ?20 :0}}>
          <WaveItem
            backgroundImage={pointer}
            topOffset={-65}
            leftOffset={left}
            waveWidth={width}
            d={d}
            strokeColor={strokeColor ? strokeColor : 'white'}
          />
        </div>
        <ArrowButton
          onClick={() => scrollToSection(nextRef)}
          icon={down}
          strokeColor={strokeColor ? strokeColor : 'white'}
        />
      </div>
    </>
  )
}

export default BottomSection
